import styled from "styled-components";
import { primary03, shade0, shade600, shade700 } from "../../styles/tokens";
import { Body } from "../body/Body";
import { Props as OverlayProps } from "./overlay/Overlay.Parts";

// TEXT

// STYLES
export const Container = styled.div<{ $disabled?: boolean }>`
  display: flex;
  width: 100%;
  gap: 0.5rem;
  align-items: center;
  cursor: ${({ $disabled }) => $disabled && "not-allowed"};
`;

export const CanvasContainer = styled.div<{
  $isDragging: boolean;
  $disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative; /* Needed for sizing the single waveform canvas */
  width: 100%;
  height: 3rem;
  cursor: ${({ $isDragging }) => ($isDragging ? "grabbing" : "pointer")};

  --waveform-played-color: ${primary03};
  --waveform-hover-color: ${shade600};
  --waveform-unplayed-color: ${shade700};

  ${({ $disabled }) =>
    $disabled
      ? `pointer-events: none;`
      : `
        &:focus-within {
          outline: 1px solid ${shade0};
          outline-offset: 1px;
        }
      `}
`;

export const TimeDisplay = styled(Body)<{ disabled?: boolean }>`
  flex-shrink: 0;
  width: 2rem;
  text-align: center;
  color: ${({ disabled }) => disabled && shade700};
`;

// DATA

// TYPES
export type Props = {
  waveform: WaveformJSON;
  totalDuration: number;
  currentTime: number;
  handlePausePlay: () => void;
  large?: boolean; // draws taller peaks to fill CanvasContainer's box fully
  showDuration?: boolean;
  showCurrentTime?: boolean;
  disabled?: boolean;
  onSeek: (duration: number) => void;
  onMove?: (duration: number) => void;
  onDrag?: (isDragging: boolean) => void;
  overlay?: OverlayProps["overlay"];
};

export type SkeletonProps = Pick<Props, "showCurrentTime" | "showDuration">;

export type WaveformJSON = {
  /** Number of peak pairs */
  length: number;
  /** Flat array of [low, high, low, high, ...] */
  data: number[];
};

// CONSTANTS
export const SEEK_STEP = 5;
export const DEFAULT_HEIGHT = 32;
export const LARGE_HEIGHT = 48;

// FUNCTIONS
export const formatTime = (seconds: number) => {
  const roundedSeconds = Math.floor(seconds);
  const minutes = Math.floor(roundedSeconds / 60);
  const remainingSeconds = roundedSeconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
};

// ASSETS
